
import React from "react";
import PDFSegmentPage from "./PDFSegmentPage";
import { groupItemsBySegmentAndSeries } from "@/utils/pdfDataUtils";
import { formatCurrency } from "@/lib/formatters";

interface OrderItem {
  id: number;
  codigo_produto: string;
  descricao_produto: string;
  preco: number;
  ano_letivo: number;
  marca: string;
  sku: string;
  status: string;
  utilizacao?: string | null;
  serie?: string | null;
  segmento?: string | null;
  quantidade_contratual: number;
  desconto: number;
  quantidade_pedido: number;
  valor_liquido: number;
  valor_total: number;
  delivery_type_id: number;
  delivery_type_number: number;
  brand_id: number;
}

interface PDFDetailedPagesProps {
  orderNumber: string;
  clientName: string;
  orderItems: OrderItem[];
}

const PDFDetailedPages = ({
  orderNumber,
  clientName,
  orderItems,
}: PDFDetailedPagesProps) => {
  const groupedData = groupItemsBySegmentAndSeries(orderItems);
  
  if (groupedData.length === 0) {
    return null;
  }
  
  const grandTotal = groupedData.reduce((sum, segment) => sum + segment.total, 0);

  return (
    <div id="pdf-detailed-content">
      {groupedData.map((segment, segmentIndex) => (
          <PDFSegmentPage
            key={`segment-${segment.nome}-${segmentIndex}`}
            segment={segment}
            segmentIndex={segmentIndex}
            totalSegments={groupedData.length}
            orderNumber={orderNumber}
            clientName={clientName}
            grandTotal={grandTotal}
          />
      ))}
    </div>
  );
};

export default PDFDetailedPages;
